/**
 * @generated SignedSource<<005485f8dfcf26c2a9a720674bb1da1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedPersonalizedSearchItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_viewer">;
  readonly " $fragmentType": "BuySharedPersonalizedSearchItems_viewer";
};
export type BuySharedPersonalizedSearchItems_viewer$key = {
  readonly " $data"?: BuySharedPersonalizedSearchItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedPersonalizedSearchItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8822a79e2ecc9a8f23d0f4c09c7a9d01";

export default node;
